import React, { useEffect, useState } from "react";
import * as S from "./ContentAccess.style";
import FlorenzButton from "../../../../florenzComponents/florenzButton";
import FlorenzSearchInput from "../../../../florenzComponents/florenceSearchInput";
import { useTranslation } from "react-i18next";
import * as P from "../../../../../utils/pipes";

function ContentAccess ({
  content
}) {  

  const {t, i18n: { language }} = useTranslation("global");  

  console.log("ajsdfjasd", content.processToMediaGroups);
  

  return (
    <S.ContentAccess>
      <div className="title-access">
        {
          P.dataTranslation(content.name, language)
        }
      </div>
      <div className="separator"></div>
      <div className="programs-access">
        {`${"Programas con acceso"} ${content.processToMediaGroups.length}`}
      </div>
      <div className="programs-list">
        {
          content.processToMediaGroups.map((item, index) => (
            <div className="program-item" key={index}>
              <div className="program-name">
                {P.dataTranslation(item.process.processName, language)}
              </div>
              <div className="program-patients">
                {`${item.process?.userToProcesses_aggregate?.aggregate.count} ${t("Pacientes")}`}
              </div>
            </div>
          ))
        }
      </div>
    </S.ContentAccess>
  )

}

export default ContentAccess;
